<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>
          <strong>Управление лейблами</strong>
          <CButton color="primary" class="float-right" @click="openCreateModal">Добавить лейбл</CButton>
        </CCardHeader>
        <CCardBody>
          <table class="table table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Название</th>
                <th>Изображение</th>
                <th>Угол</th>
                <th class="text-center">Действия</th>
              </tr>
            </thead>
            <draggable
              tag="tbody"
              v-model="labels"
              @end="onDragEnd"
              handle=".handle"
            >
              <tr v-for="label in labels" :key="label.id">
                <td class="align-middle">
                  <div class="w-16 d-flex align-items-center">
                    <CIcon
                      :height="16"
                      :content="cilCursorMove"
                      class="handle cursor-move mr-2"
                    />
                    <span>{{ label.position }}</span>
                  </div>
                </td>
                <td class="align-middle">{{ label.title }}</td>
                <td class="align-middle">
                  <img v-if="label.picture" :src="getImageUrl(label.picture)" alt="Label Image" class="label-image" />
                </td>
                <td class="align-middle">{{ getAngleLabel(label.incline) }}</td>
                <td class="text-center align-middle">
                  <CButton color="info" size="sm" class="mr-1" @click="openEditModal(label)">Редактировать</CButton>
                  <CButton color="danger" size="sm" @click="deleteLabel(label.id)">Удалить</CButton>
                </td>
              </tr>
            </draggable>
          </table>
        </CCardBody>
      </CCard>
    </CCol>

    <CModal
      :show.sync="showModal"
      :title="isEdit ? 'Редактировать лейбл' : 'Создать лейбл'"
      :footer="false"
    >
      <div slot="body-wrapper" class="modal-body">
        <form>
          <div class="form-group">
            <label for="title">Название</label>
            <input id="title" v-model="currentLabel.title" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label for="picture">Изображение</label>
            <div v-if="currentLabel.picture">
              <img :src="getImageUrl(currentLabel.picture)" alt="Current Image" class="current-image" />
            </div>
            <input type="file" @change="selectPicture" class="form-control-file" />
          </div>
          <div class="form-group">
            <label for="incline">Угол</label>
            <select id="incline" v-model="currentLabel.incline" class="form-control">
              <option v-for="option in angleOptions" :key="option.value" :value="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
        </form>
      </div>
      <div slot="footer">
        <CButton color="primary" @click="saveLabel">{{ isEdit ? 'Сохранить' : 'Создать' }}</CButton>
        <CButton color="secondary" @click="closeModal">Отмена</CButton>
      </div>
    </CModal>
  </CRow>
</template>

<script>
import Vue from 'vue';
import draggable from 'vuedraggable';
import { CIcon } from '@coreui/icons-vue';
import { cilCursorMove } from '@coreui/icons';

export default {
  name: 'LabelsManager',
  components: {
    draggable,
    CIcon,
  },
  data() {
    return {
      labels: [],
      showModal: false,
      isEdit: false,
      currentLabel: {
        id: null,
        title: '',
        picture: '',
        type: 'dish',
        incline: 1,
        position: 0,
      },
      angleOptions: [
        { value: 1, label: 'Верхний правый угол' },
        { value: 2, label: 'Верхний левый угол' },
        { value: 3, label: 'Нижний правый угол' },
        { value: 4, label: 'Нижний левый угол' },
      ],
      selectedPicture: null,
      cilCursorMove,
    };
  },
  async created() {
    await this.fetchLabels();
  },
  methods: {
    async fetchLabels() {
      try {
        const response = await this.axios.get('/labels');
        this.labels = response.data;
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка загрузки лейблов.');
      }
    },
    openCreateModal() {
      this.isEdit = false;
      this.currentLabel = {
        id: null,
        title: '',
        picture: '',
        type: 'dish',
        incline: 1,
        position: this.labels.length + 1,
      };
      this.selectedPicture = null;
      this.showModal = true;
    },
    openEditModal(label) {
      this.isEdit = true;
      this.currentLabel = { ...label };
      this.selectedPicture = null;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    selectPicture(event) {
      this.selectedPicture = event.target.files[0];
    },
    getImageUrl(filename) {
      return process.env.VUE_APP_STATIC_BASE_URL + '/' + filename;
    },
    getAngleLabel(value) {
      const option = this.angleOptions.find((opt) => opt.value === value);
      return option ? option.label : 'Неизвестно';
    },
    async saveLabel() {
      try {
        if (!this.currentLabel.title) {
          this.$root.$emit('showError', 'Укажите название лейбла.');
          return;
        }

        if (this.selectedPicture) {
          let formData = new FormData();
          formData.append('file', this.selectedPicture);
          const uploadResponse = await Vue.axios.post('/files/upload', formData);
          this.currentLabel.picture = uploadResponse.data.filename;
        }

        this.currentLabel.incline = +this.currentLabel.incline || 1;

        if (this.isEdit) {
          await this.axios.post(`/labels`, this.currentLabel);
        } else {
          await this.axios.post('/labels', this.currentLabel);
        }
        await this.fetchLabels();
        this.closeModal();
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка сохранения лейбла.');
      }
    },
    async deleteLabel(id) {
      try {
        await this.axios.delete(`/labels/${id}`);
        await this.fetchLabels();
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка удаления лейбла.');
      }
    },
    async onDragEnd() {
      try {
        for (let i = 0; i < this.labels.length; i++) {
          this.labels[i].position = i + 1;
          await this.axios.post(`/labels`, this.labels[i]);
        }
        await this.fetchLabels();
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка обновления порядка лейблов.');
      }
    },
  },
};
</script>

<style scoped>
.label-image,
.current-image {
  max-width: 100px;
  max-height: 100px;
}

.align-middle {
  vertical-align: middle !important;
}

.cursor-move {
  cursor: move;
}

.w-16 {
  width: 4rem;
}
</style>
